import { render, staticRenderFns } from "./GridCellRelationMany.vue?vue&type=template&id=37982c6b&"
import script from "./GridCellRelationMany.vue?vue&type=script&lang=js&"
export * from "./GridCellRelationMany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GridCellRelationMany.vue"
export default component.exports